import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Leaf, Clock } from 'lucide-react';
import Logo from './Logo';
import { SITE } from '../lib/site';

const QUICK_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Menu', to: '/menu' },
  { label: 'About Us', to: '/about' },
  { label: 'Contact Us', to: '/contact' },
];

const MENU_LINKS = ['Shawarma', 'NYC Gyro', 'Family Combo', 'Platters', 'Wings', 'Cool Drinks'];

export default function Footer() {
  return (
    <footer id="visit" className="text-white" style={{ background: 'var(--color-ink)' }}>
      <div className="max-w-screen-xl mx-auto px-5 md:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Logo tone="dark" size={54} />
          <p className="mt-4 text-[13px] text-white/60 leading-relaxed max-w-xs">
            Thank you for supporting local and eating halal.
          </p>
        </div>

        <div>
          <h4 className="text-xs font-extrabold uppercase tracking-[0.2em]" style={{ color: 'var(--color-yellow)' }}>
            Quick Links
          </h4>
          <ul className="mt-4 space-y-2.5">
            {QUICK_LINKS.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="inline-block py-1 text-[13px] text-white/70 hover:text-white transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-extrabold uppercase tracking-[0.2em]" style={{ color: 'var(--color-yellow)' }}>
            Menu
          </h4>
          <ul className="mt-4 space-y-2.5">
            {MENU_LINKS.map((l) => (
              <li key={l}>
                <Link to="/menu" className="inline-block py-1 text-[13px] text-white/70 hover:text-white transition-colors">
                  {l}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-extrabold uppercase tracking-[0.2em]" style={{ color: 'var(--color-yellow)' }}>
            Contact Us
          </h4>
          <ul className="mt-4 space-y-3 text-[13px] text-white/70">
            <li className="flex items-start gap-2.5">
              <Phone size={15} className="mt-0.5 shrink-0" style={{ color: 'var(--color-yellow)' }} />
              <a href={SITE.phoneHref} className="inline-block py-0.5 hover:text-white transition-colors">{SITE.phone}</a>
            </li>
            <li className="flex items-start gap-2.5">
              <Mail size={15} className="mt-0.5 shrink-0" style={{ color: 'var(--color-yellow)' }} />
              <a href={SITE.emailHref} className="inline-block py-0.5 break-all hover:text-white transition-colors">{SITE.email}</a>
            </li>
            <li className="flex items-start gap-2.5">
              <MapPin size={15} className="mt-0.5 shrink-0" style={{ color: 'var(--color-yellow)' }} />
              <span>{SITE.address}</span>
            </li>
            <li className="flex items-start gap-2.5">
              <Clock size={15} className="mt-0.5 shrink-0" style={{ color: 'var(--color-yellow)' }} />
              <span>{SITE.hours}</span>
            </li>
            <li className="flex items-center gap-2.5 pt-1">
              <Leaf size={15} className="shrink-0" style={{ color: 'var(--color-yellow)' }} />
              <span className="font-extrabold uppercase tracking-wide" style={{ color: 'var(--color-green)' }}>100% Halal Food</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-screen-xl mx-auto px-5 md:px-8 py-5 text-center text-xs text-white/50">
          &copy; {new Date().getFullYear()} {SITE.name}. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}
